<template>
  <div class="page">
    <van-nav-bar title="打卡" left-arrow @click-left="$router.go(-2)" fixed :placeholder="true"
      :safe-area-inset-top="true" />
    <!-- 顶部盒子 -->
    <div class="top-card">
      <div class="title" style="margin-top: 20px;" >应该打卡次数:{{ zdzdxss }} </div>
      <div class="title" style="margin-top: 20px;">已完成打卡次数:{{ dkcs }} </div>
    </div>
    <!-- 打卡盒子 -->
    <div class="option-card">
      <div class="sign-box">
        <div class="tip"> <img src="../../../assets/images/icon_none_choose.png" alt="" />只能实时拍照上传，不能直接上传手机相册照片</div>
       
        <van-uploader accept="image/*" capture="camera" id="dkfile" name="dkfile" style="display: none;"
          :after-read="afterRead" :max-size="5 * 1024 * 1024" @oversize="$toast('文件大小不能超过 5M ')" :max-count="1"
          v-model="fileList" />

        <div class="item" @click="sign" :style="{ backgroundImage: getBackGround }">
          <div class="name"> {{ signName }} </div>
          <div class="now"> {{ time }} </div>
        </div>
        <div class="status">
          <img src="../../../assets/images/icon_choose.png" alt="" v-if="iconType == 1" />
          <img src="../../../assets/images/icon_none_choose.png" v-else alt="" />
          <div>{{ signText }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";
import { mapGetters } from 'vuex'
export default {
  components: {
  },
  data() {
    let self = this
    return {
      signName: '无法打卡',
      signText: '',
      iconType: 0,
      stateType:0,
      timer: null,
      time: '',
      fileList: [],
      file: {},
      //应打卡次数
      zdzdxss: '',
      //已打卡次数
      dkcs: 0
    }
  },
  computed: {
    getBackGround() {
      if ( this.dkcs >= this.zdzdxss) {
        //正常打卡
        return 'linear-gradient(180deg, #B2B2B2 0%, #989898 100%)'
      } else {
        //置灰，无法打卡
        return 'linear-gradient(180deg, #0092FF 0%, #026CFE 100%)'
      }
    }
  },
  methods: {
    check(val) {
      if (val < 10) {
        return '0' + val
      } else {
        return val
      }
    },
    displayTime() {
      var date = new Date()
      var hour = date.getHours()
      var minutes = date.getMinutes()
      var second = date.getSeconds()
      this.time = this.check(hour) + ':' + this.check(minutes) + ':' + this.check(second)
      if ( this.dkcs >= this.zdzdxss) {
        this.signName = '无法打卡'
        this.iconType = 0
        this.stateType = 0;
        this.signText = '您已完成所有打卡'
      } else {
        this.signName = '打卡'
        this.signText = '您需完成打卡'
        this.iconType = 1
        this.stateType = 1;
      }
    },
    async getAttendanceInfo() {
      this.getinitData();
      this.timer = setInterval(() => {
        this.displayTime()
      }, 1000)
    },
    async getinitData() {
      let query = { xn: this.$route.query.xn }
      const res = await Api.getinitZyjhDk_JS(query);
      let data = res.data;
      this.zdzdxss = data.pcList.zdzdxss;
      this.dkcs = data.dkcs
    },
    sign() {
      if(this.stateType == 1){
        document.getElementById("dkfile").click();
      }
    },
    async afterRead(file) {
      this.file = file.file;
      let query = { file: this.file, xn: this.$route.query.xn };
      const res = await Api.zyjhdkSave_JS(query);
      if (res.errorCode === 'success') {
        this.getinitData();
        this.displayTime();
      }
      this.fileList = [];
    }
  },
  async created() {
    this.getAttendanceInfo();
  },
}
</script>

<style lang="less" scoped>
.page {
  min-height: 100vh;
  background: #f2f2f4;
  margin-top: -50px;
  padding-bottom: 50px;
}

.van-tabs__line {
  background-color: #0088f8 !important;
  width: 25px;
}

.van-tab--active {
  color: #333333 !important;
  font-weight: 600 !important;
}

.top-card {
  margin: 15px auto 10px;
  width: 315px; // 宽度会被padding撑开
  min-height: 117px;
  background: #ffffff;
  border-radius: 8px;
  padding: 15px;

  .title {
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
  }

  .time-box {
    margin-top: 15px;
    display: grid;
    // justify-content: space-between;
    // flex-wrap: wrap;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;

    .item {
      // flex: 1;
      height: 50px;
      background: #ededed;
      border-radius: 8px;
      padding-top: 6px;

      // margin-right: 10px;
      // margin-bottom: 10px;
      .time {
        margin-left: 12px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 14px;
        color: #333333;
      }

      .status {
        margin-left: 12px;
        margin-top: 4px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 12px;
        color: #666666;
        display: flex;
        align-items: center;

        img {
          width: 12px;
          height: 12px;
          margin-right: 3px;
        }
      }
    }
  }
}

.option-card {
  margin: 0 auto;
  width: 315px;
  padding: 15px;
  height: 478px;
  background: #ffffff;
  border-radius: 8px;
  position: relative;

  .address-box {
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .address {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
      }

      .option {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #0189f9;
      }
    }

    .map {
      overflow: hidden;
      margin: 12px auto 0;
      width: 315px;
      height: 90px;
      border-radius: 6px;
    }
  }

  .sign-box {
    .tip {
      margin-top: 4px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      // line-height: 14px;
      color: #999999;
      img {
        width: 12px;
        height: 12px;
        margin-right: 3px;
      }
    }
    .item {
      width: 136px;
      height: 136px;
      // background-image: linear-gradient(180deg, #0092ff 0%, #026cfe 100%);
      box-shadow: 0 8px 8px 0 rgba(1, 137, 249, 0.25);
      border-radius: 50%;
      margin: 60px auto;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .name {
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 20px;
        color: #ffffff;
        text-align: center;
      }

      .now {
        opacity: 0.5;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        font-size: 14px;
        color: #ffffff;
        text-align: center;
      }
    }

    .status {
      margin-top: 30px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 18px;
        height: 18px;
      }

      div {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        margin-left: 5px;
      }
    }
  }
}

.popup {
  position: relative;

  .header {
    height: 38px;
    position: relative;
    padding-top: 16px;
    border-bottom: 1px solid #e5e5e5;

    img {
      width: 13px;
      height: 13px;
      margin-left: 15px;
    }

    .title {
      position: absolute;
      transform: translate(-50%, -50%);
      left: 50%;
      top: 50%;
      text-align: center;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
    }
  }

  .upload {
    display: flex;
    justify-content: space-between;
    padding: 13px 15px;
    align-items: center;
    border-bottom: 1px solid #e5e5e5;

    .add {
      width: 50px;
      height: 50px;
      border: 1px solid #e5e5e5;
      border-radius: 6px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      img {
        width: 22px;
        height: 18px;
      }
    }
  }

  .remark {
    padding: 13px 15px;
  }

  .sure-button {
    position: fixed;
    bottom: 20px;
    left: 15px;
    right: 15px;
    width: 345px;
    height: 50px;
    background: #0189f9;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    margin: 0 auto;
    line-height: 50px;
    text-align: center;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 18px;
    color: #ffffff;
  }

  .sure-button:active {
    background-color: rgba(0, 0, 0, 0.1);
    opacity: 0.7;
  }
}

.total-box {
  width: 345px;
  height: 132px;
  background: #ffffff;
  border-radius: 8px;
  margin: 10px auto;

  .title {
    display: flex;
    justify-content: space-between;
    padding: 16px 20px 0 20px;

    .left {
      font-weight: bold;
      font-family: PingFangSC-Semibold;
      font-size: 16px;
      line-height: 22px;
      color: #333333;
    }
  }

  .content {
    margin-top: 16px;
    display: flex;

    .item-box {
      width: 33.33%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .top {
        font-weight: bold;
        font-family: PingFangSC-Semibold;
        font-size: 26px;
        line-height: 37px;
        color: #333333;
      }

      .bottom {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        line-height: 20px;
        color: #666666;
      }
    }
  }
}

.calendar {
  width: 345px;
  // height: 566px;
  padding-bottom: 25px;
  background: #ffffff;
  border-radius: 8px;
  margin: 0 auto;

  .title {
    padding-top: 18px;
    margin-left: 18px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    p {
      font-size: 14px;
      color: #999999;
    }
  }
}

.details {
  display: flex;
  padding: 0 15px;
  margin-top: 9px;

  .left-box {
    line-height: 22px;

    .circle {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #999999;
      margin-top: 5px;
    }

    .line {
      width: 1px;
      height: 100%;
      border-left: 1px solid #cccccc;
      background: #cccccc;
      margin-left: 4px;
      margin-top: 3px;
      margin-bottom: 6px;
    }
  }

  .right-box {
    margin-left: 18px;

    .right-title {
      display: flex;
      align-items: center;

      .text {
        font-weight: bold;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        line-height: 22px;
        color: #333333;
        max-width: 225px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .status {
        min-width: 36px;
        margin-left: 12px;
        height: 18px;
        border-radius: 9px;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        letter-spacing: 0;
        text-align: center;
        line-height: 18px;
        padding: 0 2px;
        background: #fe923f;
        color: #ffffff;
      }
    }

    .centent {
      margin-top: 8px;

      p {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        line-height: 18px;
        color: #999999;
      }
    }
  }
}

.apply-button {
  width: 82px;
  height: 28px;
  border: 1px solid #0189f9;
  border-radius: 14px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #0189f9;
  line-height: 28px;
  text-align: center;
  margin-top: 6px;
}

.sign-img {
  display: block;
  width: 40px;
  height: 40px;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  margin-top: 6px;
}

.empty-sign {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 300px;

  img {
    width: 76px;
    height: 76px;
    margin-bottom: 24px;
  }

  div {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    text-align: center;
    line-height: 18px;
  }
}

.upload {
  .van-uploader__preview-image {
    width: 50px !important;
    height: 50px !important;
    border-radius: 6px;
  }
}</style>



// WEBPACK FOOTER //
// src/components/teacher/zyjh/zyjhDk.vue